import { mdiCalendarClock } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { canViewOrganizationSettings } from "../../../../_shared/_logic/access"
import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
import type { ContextProductPage } from "@kontextwerk/control-web-frame/shared/logic/context-workspace"
import { allowsKehrblattCapability } from "../../../../../_shared/_logic/context-capabilities"

/** Same admission for the prepared navigation entry, direct route and editor. */
export const contextPlanningPage = (
  session: ContextSessionResponse | null,
  organizationId: string,
) => {
  if (
    session?.context.kind !== "organization" ||
    session.context.organization_id !== organizationId ||
    !allowsKehrblattCapability(session, "core.org_settings", "view")
  )
    return null

  return {
    id: "planning" as const,
    label: "Terminplanung",
    href: `/organizations/${organizationId}/administration/planning`,
    icon: mdiCalendarClock,
    placement: "footer",
    admission: {
      kind: "organization",
      organizationId,
      requirements: {
        operation: "kehrblatt.planning.read",
        all_of: [{ key: "core.org_settings", level: "view", scope: null }],
      },
    },
    canManage: allowsKehrblattCapability(session, "core.org_settings", "manage"),
  } satisfies ContextProductPage & { canManage: boolean }
}

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "planning",
  title: "Terminplanung",
  tooltip:
    "Planungsvorlauf, Zeitfenster, Terminpuffer und den Zeitpunkt der Terminbrief-Aufgaben festlegen.",
  icon: mdiCalendarClock,
  routeSegment: "planning",
  getPages: (context) =>
    canViewOrganizationSettings(context)
      ? [
          {
            id: "planning",
            title: "Terminplanung",
            path: "",
            widthType: "normal",
            testId: "controlAdmin.organizationView.tab.planning",
          },
        ]
      : [],
}
